import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from '../Modal';
import { Button } from '../../atoms/Button';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
}

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Onayla',
  cancelText = 'İptal',
  variant = 'danger',
  isLoading = false,
}: ConfirmDialogProps) => {
  const variantStyles = {
    danger: {
      icon: 'text-red-500',
      button: 'danger' as const,
    },
    warning: {
      icon: 'text-yellow-500',
      button: 'secondary' as const,
    },
    info: {
      icon: 'text-blue-500',
      button: 'primary' as const,
    },
  };

  const style = variantStyles[variant];

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      footer={
        <div className="flex items-center justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button
            variant={style.button}
            onClick={handleConfirm}
            isLoading={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      }
    >
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 ${style.icon}`}>
          <AlertTriangle className="w-6 h-6" />
        </div>
        <div className="flex-1">
          {typeof message === 'string' ? (
            <p className="text-gray-700 leading-relaxed">{message}</p>
          ) : (
            <div className="text-gray-700 leading-relaxed">{message}</div>
          )}
        </div>
      </div>
    </Modal>
  );
};
